import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    class: "btn btn-lg btn-primary btn-lg-square back-to-top",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args)), ["prevent"]))
  }, [...(_cache[1] || (_cache[1] = [
    _createElementVNode("i", { class: "bi bi-arrow-up" }, null, -1)
  ]))]))
}